/* import __COLOCATED_TEMPLATE__ from './reviewable-post.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
